/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateProjectLotEmployeesRequest
 */
export interface UpdateProjectLotEmployeesRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateProjectLotEmployeesRequest
     */
    agencyId: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateProjectLotEmployeesRequest
     */
    employeeIds: Array<string>;
}

/**
 * Check if a given object implements the UpdateProjectLotEmployeesRequest interface.
 */
export function instanceOfUpdateProjectLotEmployeesRequest(value: object): value is UpdateProjectLotEmployeesRequest {
    if (!('agencyId' in value) || value['agencyId'] === undefined) return false;
    if (!('employeeIds' in value) || value['employeeIds'] === undefined) return false;
    return true;
}

export function UpdateProjectLotEmployeesRequestFromJSON(json: any): UpdateProjectLotEmployeesRequest {
    return UpdateProjectLotEmployeesRequestFromJSONTyped(json, false);
}

export function UpdateProjectLotEmployeesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateProjectLotEmployeesRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'agencyId': json['agencyId'],
        'employeeIds': json['employeeIds'],
    };
}

export function UpdateProjectLotEmployeesRequestToJSON(value?: UpdateProjectLotEmployeesRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'agencyId': value['agencyId'],
        'employeeIds': value['employeeIds'],
    };
}

